import { all } from "redux-saga/effects";

const Auth = require("./Auth").default();
const Global = require("./Global").default();
const Project = require("./Project").default();
const Task = require("./Task").default();
const Phase = require("./Phase").default();
const Dashboard = require("./Dashboard").default();
const Schedule = require("./Schedule").default();
const Document = require("./Document").default();
const MyTask = require("./MyTask").default();
const Meeting = require("./Meeting").default();
const Role = require("./Role").default();
const Admin = require("./Admin").default();
const Performance = require("./Performance").default();
const Holiday = require("./Holiday").default();
// 新模組（設計稿新增的 11 個頁面）
const Approval = require("./Approval").default();
const Board = require("./Board").default();
const Report = require("./Report").default();
const Timesheet = require("./Timesheet").default();
const Audit = require("./Audit").default();
const Automation = require("./Automation").default();
const Setting = require("./Setting").default();

export default function* rootSaga() {
  const sagas = [
    Auth, Global, Project, Task, Phase, Dashboard, Schedule, Document, MyTask, Meeting,
    Role, Admin, Performance, Holiday,
    Approval, Board, Report, Timesheet, Audit, Automation,
    Setting,
  ];
  yield all(sagas);
}
